import script from "./QuillContent.vue?vue&type=script&setup=true&lang=js"
export * from "./QuillContent.vue?vue&type=script&setup=true&lang=js"

import "./QuillContent.vue?vue&type=style&index=0&id=06133754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06133754"]])

export default __exports__